module.exports = __webpack_public_path__ + "static/sliceIcon-4f6053936579f0bb4506e237933e3f99.png";